import { mergeClasses } from "@fluentui/react-components";
import { DIAGNOSTIC_METHOD_ICONS } from "apps/project-iq/components/icons/ProjectIqIcons";
import { useState } from "react";
import { formatDate } from "utils/generalUtils";
import {
  deriveDiagnosticStatus,
  METHOD_LABELS,
  STATUS_LABELS,
} from "apps/project-iq/utils/diagnosticUtils";
import { DiagnosticCardMenu } from "./DiagnosticCardMenu";
import { useDiagnosticCardStyles } from "./DiagnosticCard.styles";
import { IDiagnosticCardProps } from "./DiagnosticCard.types";

export const DiagnosticCard = ({
  diagnostic,
  onNavigate,
  onEdit,
  onDelete,
}: IDiagnosticCardProps): JSX.Element => {
  const styles = useDiagnosticCardStyles();
  const [isHovered, setIsHovered] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const status = deriveDiagnosticStatus(diagnostic);

  const statusPillClass = mergeClasses(
    styles.diagnosticCardStatusPill,
    status === "in_progress"
      ? styles.diagnosticCardStatusInProgress
      : status === "completed"
        ? styles.diagnosticCardStatusCompleted
        : styles.diagnosticCardStatusDraft,
  );

  const formattedDate = formatDate(diagnostic.createdAt);

  const methodIcon = DIAGNOSTIC_METHOD_ICONS[diagnostic.method];

  return (
    <div
      className={styles.diagnosticCard}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        className={styles.diagnosticCardButton}
        aria-label={diagnostic.name}
        onClick={onNavigate}
      >
        <div className={styles.diagnosticMethodIcon} aria-hidden="true">
          {methodIcon}
        </div>
        <div className={styles.diagnosticCardBody}>
          <div className={styles.diagnosticCardNameRow}>
            <span className={styles.diagnosticCardName}>{diagnostic.name}</span>
            <span className={statusPillClass}>{STATUS_LABELS[status]}</span>
          </div>
          <p
            className={
              diagnostic.description
                ? styles.diagnosticCardDescription
                : styles.diagnosticCardDescriptionEmpty
            }
            title={diagnostic.description || undefined}
          >
            {diagnostic.description || "No description"}
          </p>
          <div className={styles.diagnosticCardMeta}>
            <span className={styles.diagnosticCardMetaMethod}>
              {METHOD_LABELS[diagnostic.method]}
            </span>
            <span aria-hidden="true">&bull;</span>
            <span>{formattedDate}</span>
          </div>
        </div>
      </button>
      <div
        className={mergeClasses(
          styles.menuArea,
          (isHovered || isMenuOpen) && styles.menuAreaVisible,
        )}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <DiagnosticCardMenu
          onEdit={onEdit}
          onDelete={onDelete}
          onOpenChange={setIsMenuOpen}
        />
      </div>
    </div>
  );
};
